import React from "react";
import offers1 from  './images/offers1.png';
import offers2 from  './images/offers2.png';
import offers3 from  './images/offers3.png';


export default function () {
  return (
    <div>
      <section
        id="special-offers"
        className="row container  mx-auto mt-5 mb-5  ">
        <h2 className="mb-5 card-title">Special Offers</h2>
        <div className="col-md-4 col-12  mx-auto">
          <div className="card ">
            <img src={offers1} className="card-img" alt="..." />
            <div className="card-img-overlay">
              <h5 className="card-title mt-5 " id="offer-card">
                Kerala River View Tour
              </h5>
              <span className="container text-light fs-6 ">
                {" "}
                12 Places | 3 Activities{" "}
              </span>
              <p className=" text-light fs-5 ">12 Places</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 offers disable col-6 mx-lg-0 mx-5">
          <div className="card ">
            <img src={offers2} className="card-img " alt="..." />
            <div className="card-img-overlay">
              <h5 className="card-title mt-5 " id="offer-card">
                Kerala River View Tour
              </h5>
              <span className="container text-light fs-6 ">
                {" "}
                12 Places | 3 Activities{" "}
              </span>
              <p className=" text-light fs-5 ipads-disable">12 Places</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 disable ipads-disable">
          <div className="card ">
            <img src={offers3} className="card-img" alt="..." />
            <div className="card-img-overlay">
              <h5 className="card-title mt-5 " id="offer-card">
                Kerala River View Tour
              </h5>
              <span className="container text-light fs-6 ">
                {" "}
                12 Places | 3 Activities{" "}
              </span>
              <p className=" text-light fs-5">12 Places</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
